import React, { Suspense, lazy } from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
// Lazy load below-fold sections
const Reframe = lazy(() => import('./components/Reframe').then(m => ({
  default: m.Reframe
})));
const ProductPresentation = lazy(() => import('./components/ProductPresentation').then(m => ({
  default: m.ProductPresentation
})));
const Testimonials = lazy(() => import('./components/Testimonials').then(m => ({
  default: m.Testimonials
})));
const Bonuses = lazy(() => import('./components/Bonuses').then(m => ({
  default: m.Bonuses
})));
const ValueStack = lazy(() => import('./components/ValueStack').then(m => ({
  default: m.ValueStack
})));
const TargetAudience = lazy(() => import('./components/TargetAudience').then(m => ({
  default: m.TargetAudience
})));
const Guarantee = lazy(() => import('./components/Guarantee').then(m => ({
  default: m.Guarantee
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const PurchaseSection = lazy(() => import('./components/PurchaseSection').then(m => ({
  default: m.PurchaseSection
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const SocialProofPopup = lazy(() => import('./components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
export function App() {
  return <div className="min-h-screen bg-brand-black font-sans text-brand-black selection:bg-brand-green selection:text-brand-black" data-id="element-0">
      {/* Critical above-fold content */}
      <Hero data-id="element-1" />
      <PainPoints data-id="element-2" />

      {/* Lazy-loaded below-fold content */}
      <Suspense fallback={null} data-id="element-3">
        <Reframe data-id="element-4" />
        <ProductPresentation data-id="element-5" />
        <Testimonials data-id="element-6" />
        <Bonuses data-id="element-7" />
        <ValueStack data-id="element-8" />
        <TargetAudience data-id="element-9" />
        <Guarantee data-id="element-10" />
        <FAQ data-id="element-11" />
        <PurchaseSection data-id="element-12" />
        <Footer data-id="element-13" />
        <SocialProofPopup data-id="element-14" />
      </Suspense>
    </div>;
}